import React from 'react';
import cx from 'classnames';
import styles from './freshsalesConfigurationView.module.scss';
import isEqual from 'is-equal';
import {toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import {
  Row, Col, Image,
  FormGroup, InputGroup, FormControl, Form
} from 'react-bootstrap';
import Slider from 'react-slick';
import SwitchButton from "src/components/switchButton";
import ProtectedInputField from './components/ProtectedInputField';
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import FreshsalesOne from 'src/legacy/images/fs-one.png';
import FreshsalesTwo from 'src/legacy/images/fs-two.png';
import FreshsalesThree from 'src/legacy/images/fs-three.png';
import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import CloseIcon from 'src/legacy/images/close-icon.png'
import ChromeExtensionLogo from 'src/legacy/images/chrome.svg'
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';

class FreshsalesConfigurationView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: '',
      apiKey: {},
      analyticsKey: {},
      syncReadAssetEvent: false,
      syncReadConversationEvent: false,
      syncReshareConversationEvent: false,
      syncDeals: false,
      errors: {},
      showOnboarding: this.props.showOnboarding || false
    }
    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);
    this._handleApiKeyChange = this._handleApiKeyChange.bind(this);
    this._handleAnalyticsKeyChange = this._handleAnalyticsKeyChange.bind(this);
    this._toggleOnboarding = this._toggleOnboarding.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedFreshSales = localizedStrings.components.integrations.freshsales;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    this.setState({
      domain: '',
      apiKey: {}
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.errors != nextProps.errors) {
      var errors = this.state.errors;

      if (nextProps.errors) {
        nextProps.errors.forEach(error => {
          errors[error.field] = error.message;
        })
      } else {
        errors = {}
      }

      this.setState({
        errors: errors
      })
    }

    if (!isEqual(nextProps.integration, this.props.integration)) {
      this.setState({
        domain: nextProps.integration.configuration.domainName,
        apiKey: {
          value: this.state.apiKey.value,
          current: nextProps.integration.apikey
        },
        analyticsKey: {
          value: this.state.analyticsKey.value,
          current: nextProps.integration.analyticsKey
        },
        syncReadAssetEvent: nextProps.integration.configuration.syncReadAssetEvent,
        syncReadConversationEvent: nextProps.integration.configuration.syncReadConversationEvent,
        syncReshareConversationEvent: nextProps.integration.configuration.syncReshareConversationEvent,
        syncDeals: nextProps.integration.configuration.syncDeals
      })
    }

    if (!isEqual(this.props.showOnboarding, nextProps.showOnboarding)) {
      this.setState({
        showOnboarding: nextProps.showOnboarding
      })
    }
  }


  _toggleOnboarding() {
    this.props.toggleOnboarding();
  }

  _handleFieldChange(field, e) {
    let value = e.target.value;
    this.setState({
      [field]: value,
      errors: {}
    });
  }

  _handleApiKeyChange(value) {
    this.setState({
      apiKey: {
        ...this.state.apiKey,
        ...value
      }
    });
  }

  _handleAnalyticsKeyChange(value) {
    this.setState({
      analyticsKey: {
        ...this.state.analyticsKey,
        ...value
      }
    });
  }

  _toggleSwitchChange(field) {
   

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked() {
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    let request = {
      apiKey: this.state.apiKey.value,
      domain: this.state.domain,
      analyticsKey: this.state.analyticsKey.value,
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncDeals: this.state.syncDeals
    }

    this.props.authenticateAccount(request).then((res) => {
      if(!res) {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.freshsales}            
          /> , {
            autoClose: 3000,
        })
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Freshsales')
        this.props.toggleOnboarding();

      } 
    });
  }

  _handleResetClicked() {
    this.setState({
      domain: this.props.integration.configuration.domainName,
      apiKey: {
        value: '',
        current: this.props.integration.apikey
      },
      analyticsKey: {
        value: '',
        current: this.props.integration.analyticsKey
      },
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent,
      syncDeals: this.props.integration.configuration.syncDeals
    });
  }

  _validateForm() {
    var errors = {};
    if (this.props.user.admin && (!this.state.domain || this.state.domain.trim() == '')) {
      errors['domain'] = this.localizedFreshSales.details.error_message.domain;
    }

    return errors;
  }

  render() {
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this.props.user.admin && this._renderAdminConfiguration()}

        {}

        {!this.props.loading && !this.props.user.admin && this.props.integration && this._renderUserConfiguration()}

        {!this.props.loading && !this.props.user.admin && !this.props.integration && this._renderEmptyMessage()}
      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} mdOffset={1}>
          <div className={styles.form}>
            <p className={styles.errorMessage}>{this._renderError()}</p>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedFreshSales.details.domain_name }</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder={ this.localizedFreshSales.details.placeholders.domain }
                  value={this.state.domain}
                  onChange={this._handleFieldChange.bind(this, 'domain')} />
                <InputGroup.Text className={styles.end}>
                  <span>.freshsales.io</span>
                </InputGroup.Text>
              </InputGroup>
            </FormGroup>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedFreshSales.details.api_key }</span>
                </InputGroup.Text>
                <ProtectedInputField
                  type='password'
                  className={styles.apiKey}
                  placeholder={ this.localizedFreshSales.details.placeholders.api_key }
                  value={this.state.apiKey}
                  onChange={this._handleApiKeyChange}
                  actionButton="CHANGE API KEY"
                />
              </InputGroup>
            </FormGroup>
            <Form.Text>{ this.localizedFreshSales.details.sub_texts.api_key }</Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedFreshSales.details.analytics_key }</span>
                </InputGroup.Text>
                <ProtectedInputField
                  type='password'
                  className={styles.apiKey}
                  placeholder={ this.localizedFreshSales.details.placeholders.analytics_key }
                  value={this.state.analyticsKey}
                  onChange={this._handleAnalyticsKeyChange}
                  actionButton="CHANGE ANALYTICS KEY" />
              </InputGroup>
            </FormGroup>
            <Form.Text>{ this.localizedFreshSales.details.sub_texts.analytics_key }</Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text>{ this.localizedFreshSales.details.config }</Form.Text>
            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                <SwitchButton 
                  id="syncReadAssetEvent"
                  label=""
                  checked={this.state.syncReadAssetEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                <SwitchButton 
                  id="syncReadConversationEvent"
                  label=""
                  checked={this.state.syncReadConversationEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                <SwitchButton 
                  id="syncReshareConversationEvent"
                  label=""
                  checked={this.state.syncReshareConversationEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.sync_deals }</label>
                <SwitchButton 
                  id="syncDeals"
                  label=""
                  checked={this.state.syncDeals}
                  handleCheck={()=>this._toggleSwitchChange("syncDeals")}
                />
              </div>
            </FormGroup>
            <div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                icon="fa-chevron-right"
                title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save}
                primary
                disabled={this.props.updating}
                onClick={this._handleSaveChangesClicked}
              >
              </SendButton>
              <SendButton
                title={this.localizedCommons.actions.reset}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
                onClick={this._handleResetClicked}
              >
              </SendButton>
            </div>
          </div>
        </Col>
        {this.state.showOnboarding &&
          this._renderOnboardingPage()
        }
      </Row>
    );
  }

  _renderOnboardingPage(){
    var settings = {
      dots: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      center: true,
      dotsClass: styles.dots,
      variableWidth: false,
      adaptiveHeight: false,
      draggable: false,
      prevArrow: this.renderPreviousArrow(),
      nextArrow: this.renderNextArrow()
    };

    return (
      <Col sm={12} className={styles.freshSalesOnboarding}>
        <Row className={styles.row}>
            <Col sm={12}>
              <div className={styles.closeIcon} onClick={this._toggleOnboarding}><Image src={CloseIcon} /></div>
              <p className={styles.freshSalesHeading}>{ this.localizedFreshSales.details.onboarding_page.title }</p>
              <div>
                <Slider
                  {...settings}
                  className={cx(styles.carousel)}>
                  <div className={styles.slide}>
                    <Row>
                      <Col sm={12}>
                        <div className={styles.slideText}>
                          <h1>{ this.localizedFreshSales.details.onboarding_page.download.title }</h1>
                          <p className={styles.greyText}>{ this.localizedFreshSales.details.onboarding_page.download.sub_text }</p>
                          <p><a href="https://chrome.google.com/webstore/detail/paperflite-extension-for/gghdahjgeomeiohiecmfmdomeighihih" target="_blank" className={styles.italicText}>{ this.localizedFreshSales.details.onboarding_page.download.click_here }</a> <span className={styles.greyText}> { this.localizedFreshSales.details.onboarding_page.download.chrome_extension }<a href="https://chrome.google.com/webstore/detail/paperflite-extension-for/gghdahjgeomeiohiecmfmdomeighihih" target="_blank"><Image src={ChromeExtensionLogo} className={styles.chromeExtensionLogo} /></a></span></p>
                        </div>
                        <Image src={FreshsalesOne} />
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.slide}>
                    <Row>
                      <Col sm={12}>
                        <div className={styles.slideText}>
                          <h1>{ this.localizedFreshSales.details.onboarding_page.add_content.title }</h1>
                          <p className={styles.greyText}>{ this.localizedFreshSales.details.onboarding_page.add_content.sub_text }</p><p>{ this.localizedFreshSales.details.onboarding_page.add_content.description }</p>
                        </div>
                        <Image src={FreshsalesTwo} />
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.slide}>
                    <Row>
                      <Col sm={12}>
                        <div className={styles.slideText}>
                          <h1>{ this.localizedFreshSales.details.onboarding_page.view_analytics.title }</h1>
                          <p className={styles.greyText}>{ this.localizedFreshSales.details.onboarding_page.view_analytics.sub_text }</p>
                            <p className={styles.greyText}>
                              {localizedStrings.formatString(this.localizedFreshSales.details.onboarding_page.view_analytics.description,
                                <a href="https://views.paperflite.com/assets/5c4ed9a2c9e77c0001ec0f56" target="_blank"><span className={styles.italicText}>{this.localizedFreshSales.details.onboarding_page.view_analytics.steps}</span></a>
                              )}
                            </p>
                        </div>
                        <Image src={FreshsalesThree} />
                      </Col>
                    </Row>
                  </div>
                </Slider>
              </div>
            </Col>
        </Row>
      </Col>
    );
  }

  renderNextArrow() {
    return (
      <div>
        <span className='fa fa-angle-right'></span>
      </div>
    );
  }

  renderPreviousArrow() {
    return (
      <div>
        <span className='fa fa-angle-left'></span>
      </div>
    );
  }

  _renderUserConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} mdOffset={1}>
          <div className={styles.form}>
            <p className={styles.errorMessage}>{this._renderError()}</p>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedFreshSales.details.api_key }</span>
                </InputGroup.Text>
                <ProtectedInputField
                  type='password'
                  className={styles.apiKey}
                  placeholder={ this.localizedFreshSales.details.placeholders.api_key }
                  value={this.state.apiKey}
                  onChange={this._handleApiKeyChange}
                  actionButton="CHANGE API KEY"
                />
              </InputGroup>
            </FormGroup>
            <Form.Text>{ this.localizedFreshSales.deatils.sub_texts.api_key }</Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <InputGroup.Text>
                  <span>{ this.localizedFreshSales.details.domain_name }</span>
                </InputGroup.Text>
                <InputGroup>
                  <InputGroup.Text>
                    <span className={styles.domain}>{this.state.domain || ''}</span>
                  </InputGroup.Text>
                </InputGroup>
              </InputGroup>
            </FormGroup>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text>{ this.localizedFreshSales.details.config }</Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                <SwitchButton name="syncReadAssetEvent"
                  label=""
                  defaultChecked={this.state.syncReadAssetEvent}
                  onChange={this._toggleSwitchChange}
                  disabled={true} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection}</label>
                <SwitchButton name="syncReadConversationEvent"
                  label=""
                  defaultChecked={this.state.syncReadConversationEvent}
                  onChange={this._toggleSwitchChange}
                  disabled={true} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                <SwitchButton name="syncReshareConversationEvent"
                  label=""
                  defaultChecked={this.state.syncReshareConversationEvent}
                  onChange={this._toggleSwitchChange}
                  disabled={true} />
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.sync_deals }</label>
                <SwitchButton name="syncDeals"
                  label=""
                  defaultChecked={this.state.syncDeals}
                  onChange={this._toggleSwitchChange}
                  disabled={true} />
              </div>
            </FormGroup>


            <div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                icon="fa-chevron-right"
                title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save}
                primary
                disabled={this.props.updating}
                onClick={this._handleSaveChangesClicked}
              >
              </SendButton>
              <SendButton
                title={this.localizedCommons.actions.reset}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
              >
              </SendButton>
            </div>
          </div>
        </Col>
      </Row>
    )
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedFreshSales.details.error_message.title}
        message={this.localizedFreshSales.details.error_message.no_access}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={this.localizedFreshSales.loading}
        visible={true} />
    )
  }

  _renderError() {
    if(this.state.errors) {
      if(this.state.errors.apikey) {
        return this.state.errors.apikey;
      } else if (this.state.errors.domain) {
        return this.state.errors.domain;
      } else {
        return '';
      }
    }
  }
}


export default FreshsalesConfigurationView;